import { Flex, Typography } from '@banhala/ui-kit';
import { useConfigs } from 'shared/src/queries';

export const LegalInfo: React.FC<{
  onChangeHeight: (height: number) => void;
}> = props => {
  const { data: config } = useConfigs();

  return (
    <Flex
      onLayout={({ nativeEvent }) => {
        props.onChangeHeight(nativeEvent.layout.height);
      }}
      backgroundColor={'bg_secondary'}
      padding={{ horizontal: 16, vertical: 20, bottom: 76 }}
    >
      <Typography color={'content_tertiary'} type={'body5'}>
        {config?.legal_text ?? ''}
      </Typography>
    </Flex>
  );
};
